<template>
  <div class="topten-barchart_card">
    <el-row class="topten-barchart_card_content">
      <el-col :span="8" class="topten-barchart_top_entities">
        <el-row class="topten-barchart_top_entities_headers">
          <el-col>
            <el-tag
              size="small"
              type="info"
              effect="plain"
              :class="{
                'cursor-pointer': !statsLoading && !chartLoading,
                'cursor-wait': statsLoading || chartLoading,
                active: selectedTopTenOption === topTenSelect.value
              }"
              v-for="topTenSelect in topTenOptions"
              :key="topTenSelect.value"
              @click="changeTopTenSelection(topTenSelect, $event)"
              >{{ topTenSelect.label }}</el-tag
            >
          </el-col>
        </el-row>
        <el-row v-loading="statsLoading" class="topten-barchart_top_entities_rows">
          <top-ten-card
            v-if="selectedTopTenOption === 'top'"
            :entries="topStats"
            :col-headers="colHeaders"
            :starting-page-num="startPageNo"
            @top-ten-click="emitTopTenSelection"
            ref="toptenCard"
          ></top-ten-card>
          <top-ten-card
            v-if="selectedTopTenOption === 'bottom'"
            :entries="bottomStats"
            :col-headers="colHeaders"
            :starting-page-num="startPageNo"
            @top-ten-click="emitTopTenSelection"
            ref="toptenCard"
          ></top-ten-card>
          <top-ten-card
            v-if="selectedTopTenOption === 'new'"
            :entries="newStats"
            :col-headers="colHeaders"
            :starting-page-num.sync="startPageNo"
            @top-ten-click="emitTopTenSelection"
            ref="toptenCard"
          ></top-ten-card>
        </el-row>
      </el-col>
      <el-col :span="16" class="topten-barchart_chart">
        <bar-chart-js
          v-loading="chartLoading"
          class="c-stats_row_hrly_item"
          :chart-id="'dns-stats'"
          :chart-data="barchartStats.chartData"
          :chart-options="barchartStats.chartOptions"
        ></bar-chart-js>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import BarChartJs from "@/components/chart/BarChartJs.vue";
import TopTenCard from "@/components/card/TopTenCard.vue";

export default {
  name: "TopTenBarChartCard",
  props: {
    barchartStats: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
    colHeaders: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
    topStats: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
    bottomStats: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
    newStats: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
    defaultStats: { type: String, default: "top" },
    statsLoading: { type: Boolean, default: false },
    chartLoading: { type: Boolean, default: false }
  },
  data() {
    return {
      topTenOptions: [
        { label: "New", value: "new" },
        { label: "Top", value: "top" },
        { label: "Bottom", value: "bottom" }
      ],
      selectedTopTenOption: this.defaultStats,
      disableChartClick: false,
      chartSelectionTag: [],
      startPageNo: 1
    };
  },
  mounted() {},
  methods: {
    changeTopTenSelection(topTenSelect, event) {
      if (this.statsLoading || this.chartLoading) {
        return false;
      }
      this.$refs["toptenCard"].resetPageNum();
      if (topTenSelect.value !== this.selectedTopTenOption) {
        this.$emit("topten-change", topTenSelect.value);
      }
      this.selectedTopTenOption = topTenSelect.value;
    },
    emitTopTenSelection(row) {
      this.$emit("stats-click", row);
    },
    chartClickFunction(evt, item) {
      if (this.disableChartClick) {
        return false;
      }
      this.$emit("chart-click", item[0]);
      this.chartSelectionTag.push(item[0]._model.label);
      this.disableChartClick = !this.disableChartClick;
    },
    removeChartTagSelection(tag) {
      this.$emit("chart-unclick");
      this.chartSelectionTag.pop();
      this.disableChartClick = !this.disableChartClick;
    }
  },

  components: {
    BarChartJs,
    TopTenCard
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/riskscore_colors.css";
.topten-barchart_card {
  height: 100%;
}

.topten-barchart_card_content {
  height: 95%;
}

.topten-barchart_top_entities,
.topten-barchart_chart {
  height: inherit;
}

.topten-barchart_top_entities {
  border: 1px solid var(--border-color);
  padding: 8px;
}

.topten-barchart_top_entities_rows {
  height: calc(100% -35px);
}

.el-tag {
  margin: 0px 10px 10px 0px;

  &.active {
    color: #409eff;
    border: 1px solid #d9ecff;
    background-color: #ecf5ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/insights/TopTenBarChartCard.vue